// extracted by mini-css-extract-plugin
export default {"RulesPage":"RulesPage_RulesPage__BnB4d","RulesPage__heading":"RulesPage_RulesPage__heading__AtFRu","RulesPage__paragraph":"RulesPage_RulesPage__paragraph__wsDid"};